'use strict';
import angular from 'angular';
import moment from 'moment';

angular.module('app.ctrls')

    .controller('HeaderController', HeaderController);

/**
 * @ngInject
 */
function HeaderController(
    $rootScope,
    $scope,
    DateRangeService,
    ClusterService,
    NotificationsService,
    $ioAlert,
    $state,
    creativesService,
    Upload,
    CurrentUser
) {
    var isDataCalled = false;

    //initialize the date picker required scope vars

    $scope.ioDate = { 'startDate': moment().subtract(29, 'days').format('YYYY-MM-DD').toString(), 'endDate': moment().format('YYYY-MM-DD').toString(), 'label': 'Last 30 Days' };
    $scope.datePickerVisible = false;
    $scope.dateRangePermissions = false;
    $scope.initCluster = false;
    $rootScope.isCloudinary = false;
    $scope.uploadNotifications = [];
    $scope.toggled = toggled;
    $scope.refreshNotifications = refreshNotifications;
    $scope.showView = showView;
    $scope.mayListClusters = false;

    registerEvents();

    CurrentUser.get().then(function(user) {
        $scope.user = user;
        init();
    });

    function init() {
        DateRangeService.setDefaultDates();
        $scope.datePickerVisible = DateRangeService.enabled;
        if ($scope.user.isAuthorizedToListClusters()) {
            $scope.dateRangePermissions = true;
        } else {
            $scope.initRun = false;
        }
    }

    function toggled() {
        if (!isDataCalled) {
            isDataCalled = true;
            getCurrentNotifications();
        }
    }

    function refreshNotifications() {
        getCurrentNotifications();
    }

    function showView(notification) {
        switch (parseInt(notification.object_type_id)) {
            case NotificationsService.NOTIFICATION_OBJECT_TYPE_ORDER:
                $state.go('viewOrder', {
                    id: notification.object_id
                });
                break;
            case NotificationsService.NOTIFICATION_OBJECT_TYPE_LINE_ITEM:
                $state.go('viewLineItem', {
                    lineItemId: notification.object_id
                });
                break;
            case NotificationsService.NOTIFICATION_OBJECT_TYPE_TASK:
                $state.go('myTasksView', {
                    taskId: notification.object_id
                });
                break;
            case NotificationsService.NOTIFICATION_OBJECT_TYPE_COMMENT:
                handleCommentRedirect(
                    notification.table_name,
                    notification.table_row_id,
                );
                break;
            default:
                console.log('Notification type: ' + notification.object_type_id + ' not support');
        };
    }

    function handleCommentRedirect(table_name, table_row_id) {
        if (table_name == 'order') {
            $state.go('viewOrder', {
                id: table_row_id
            });
        } else if (table_name == 'line_item') {
            $state.go('viewLineItem', {
                lineItemId: table_row_id
            });
        } else if (table_name?.indexOf('task') > -1) {
            $state.go('myTasksView', {
                taskId: table_row_id
            });
        }
    }

    function classifyNotifications() {
        if($scope.notifications) {
            for (var i = 0; i < $scope.notifications.length; i++) {
                if ($scope.notifications[i].object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_ORDER) {
                    $scope.notifications[i].type = "Order";
                    $scope.notifications[i].href = '"viewOrder({id:' + $scope.notifications[i].object_id + '}"';
                } else if ($scope.notifications[i].object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_LINE_ITEM) {
                    $scope.notifications[i].type = "LineItem";
                    $scope.notifications[i].href = '"viewLineItem({lineItemId:' + $scope.notifications[i].object_id + '}"';
                } else if ($scope.notifications[i].object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_TASK) {
                    $scope.notifications[i].type = "Tasks";
                    $scope.notifications[i].href = '"myTasksView({taskId:' + $scope.notifications[i].object_id + '}"';
                }
            }
        }
    }

    function getCurrentNotifications() {
        NotificationsService.getSomeSiteNotifications().then(function() {
            $scope.notifications = NotificationsService.notifications;
            classifyNotifications();
            $scope.loading = false;
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function registerEvents() {

        //required broadcast listener for showing the date picker
        $rootScope.$on('enableDatePicker', function() {
            $scope.datePickerVisible = true;
        });

        //required broadcast listener for hiding the date picker
        $rootScope.$on('disableDatePicker', function() {
            $scope.datePickerVisible = false;
        });

        $rootScope.$on('dateRangePicker:change', function(event, args) {
            if (DateRangeService.mode && DateRangeService.mode === 'enabled') {
                $scope.datePickerVisible = true;
            }
            if (DateRangeService.mode && DateRangeService.mode !== 'enabled') {
                $scope.datePickerVisible = false;
            }
            DateRangeService.startDate = DateRangeService.format(args.start);
            DateRangeService.endDate = DateRangeService.format(args.end);
        });

        $rootScope.$on('initCluster', function() {
            $scope.initCluster = false;
        });

        //required broadcast listener for cloudinary image upload
        $rootScope.$on('cloudinaryImageUpload', function(event, successObj, file, additionalParams) {
            if (successObj.errors) {
                $ioAlert.show('Error!', successObj.errors, 'error');
                return;
            }
            if (!file.size) {
                $ioAlert.show('Error!', 'File size is undefined for the file: ' + additionalParams.file_name, 'error');
                $ioAlert.show('Error!', 'Please try again', 'error');
                console.log(file);
                return;
            }

            file.ioAlert = $ioAlert;
            $scope.uploadNotifications.push(file);
            let XUniqueUploadId = + new Date();
            let size = file.size;
            let sliceSize = 100000000; //100MB for each piece
            let start = 0;
            console.log("Total Size: " + file.size);
            console.log("Start Time: " + (new Date()).toISOString());

            processFile();

            function processFile() {
                var end = start + sliceSize;

                if(end>size){
                    end=size;
                }
                var s = slice(file, start, end);
                send(s, start, end-1,size);
                if (end < size) {
                    start += sliceSize;
                }
            }

            function send(piece, start, end, size) {
                console.log("start ", start);
                console.log("end" , end);

                file.upload = Upload.upload({
                    url: 'https://api.cloudinary.com/v1_1/' + successObj.cloud_name + '/auto/upload',
                    params: {
                        "api_key": successObj.api_key,
                        "folder": successObj.folder,
                        "public_id": successObj.public_id,
                        "upload_preset": successObj.upload_preset,
                        "overwrite": successObj.overwrite,
                        "signature": successObj.signature,
                        "timestamp": successObj.timestamp
                    },
                    headers: {
                        'X-Unique-Upload-Id': XUniqueUploadId,
                        'Content-Range': "bytes " + start + "-" + end + "/" + size,
                    },
                    file: piece
                });
                file.upload.then(function(response) {
                    console.log(response.data);
                    processResponse(response.status, response.data);
                }, function(response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function(evt) {
                    //console.log((start + evt.loaded) + "/" + size);
                    file.value = Math.min(100, parseInt(100.0 * (start + evt.loaded) / size));
                });
            }

            function slice(file, start, end) {
                let slice = file.mozSlice ? file.mozSlice :
                    file.webkitSlice ? file.webkitSlice :
                        file.slice ? file.slice : noop;
                return slice.bind(file)(start, end);
            }

            function noop() {}

            function processResponse(status, response) {
                if(status != 200) {
                    if (status > 0) {
                        $scope.errorMsg = status + ': ' + response;
                    }
                } else {
                    if(!response) {
                        return;
                    }
                    if(response.done == false) {
                        processFile();
                        return;
                    }
                    response.file_name = additionalParams.file_name;
                    response.file_size = additionalParams.file_size;
                    response.original_filename = successObj.public_id;
                    file.result = response;
                    var paramObj = { fileInfo: response };
                    paramObj.sharedTask = additionalParams.sharedTask;
                    switch (additionalParams.from) {
                        case 'client':
                            paramObj.clientId = additionalParams.clientId;
                            paramObj.libraryCreative = "yes";
                            break;
                        case 'lineItem':
                            paramObj.lineItemId = additionalParams.lineItemId;
                            paramObj.libraryCreative = additionalParams.libraryCreative;
                            break;
                        case 'order':
                            paramObj.orderId = additionalParams.orderId;
                            paramObj.libraryCreative = additionalParams.libraryCreative;
                            break;
                        case 'flight':
                            paramObj.flightId = additionalParams.flightId;
                            paramObj.libraryCreative = additionalParams.libraryCreative;
                            break;
                    }

                    creativesService.addCloudinaryCreative(paramObj).then(function(success) {
                        if (additionalParams.isTasksPage) {
                            $rootScope.$broadcast('tasksUploadSuccess', success.creative, additionalParams);
                        } else if (additionalParams.from == 'client') {
                            $rootScope.$broadcast('clientUploadSuccess');
                        } else if (additionalParams.section && additionalParams.section == 'comments') {
                            $rootScope.$broadcast('commentsUploadSuccess');
                        } else if (additionalParams.from == 'lineItem') {
                            $rootScope.$broadcast('lineItemUploadSuccess', success.creative, additionalParams);
                        } else if (additionalParams.from == 'order') {
                            $rootScope.$broadcast('orderUploadSuccess', success.creative, additionalParams);
                        } else if (additionalParams.from == 'flight') {
                            $rootScope.$broadcast('flightUploadSuccess', success.creative, additionalParams);
                        }
                        $ioAlert.show('', 'File uploaded Successfully', 'success');
                    }, function(error) {
                        $ioAlert.show('Error!', 'Could not addCloudinaryCreative.', 'error');
                    });
                } // end of if else
            } // end of processResponse
        }); //end of cloudinaryImageUpload
    }
}
